export const AMP_TYPES = {
  INVERTING: 1,
  NON_INVERTING: 2,
  BUFFER: 3,
};

export default {
  API_TOOL_ID: 7,

  PRETTY_NUM: {
    ENGINEERING: 'Engineering',
  },

  MODAL_TYPES: {
    CHOOSE_PART: {
      value: 'choose-part',
      default: false,
    },
    CHOOSE_DAC: {
      value: 'choose-dac',
      default: false,
    },
    CHOOSE_SIGNAL_CHAIN_PART: {
      value: 'choose-signal-chain-part',
      default: false,
    },
    HELP: {
      value: 'help',
      default: false,
    },
    ABOUT: {
      value: 'about',
      default: false,
    },
    FEEDBACK: {
      value: 'feedback',
      default: false,
    },
    PARAMETER_SELECTOR: {
      value: 'parameter-selector',
      default: false,
    },
  },

  DEFAULTS: {
    ARTICLE: 'a',
    OUTPUT_RESISTOR_VALUE: 10000,
    CDP_PARAM: { displayValue: '', value: null, name: '' },
  },

  SUPPORTED_PSTS: {
    VOLTAGE_REFERENCE: 13004, // Series Voltage Reference
    OPERATIONAL_AMP: 11070, // Operational Amplifier
    MULTIPLYING_DAC: 11390, // Multiplying DACS
    VOLTAGE_OUTPUT_DAC: 11477, // Voltage Output DACS
    CURRENT_SOURCE_DAC: 11040, //4-20mA Current Loop DAC
    CURRENT_SOURCE_SINK_DAC: 11818,
    FAST_PRECISION_DAC: 11819, // Fast Precision DAC
  },

  PST_DATABOOK_MAPPING: {
    13004: 'voltageReference',
    11070: 'opAmp',
    11390: 'multiplyingDac',
    11477: 'voltageOutputDac',
    11040: 'currentSourceDac',
    11818: 'currentSourceSinkDac',
    11819: 'fastPrecisionDac',
  },

  APP_PARAMS: {
    MIN_OPERATING_TEMP: 'minoperatingtemp',
    MAX_OPERATING_TEMP: 'maxoperatingtemp',
    POWER_SUPPLY_RIPPLE: 'powersupplyripple',
    CALIBRATION: 'calibration',
  },

  CHART_TYPES: {
    ERROR_DISTRIBUTION: 'errorDistribution',
  },

  RESISTOR_PARAMS: {
    R: 'r',
    R1: 'r1',
    R2: 'r2',
    R3: 'r3',
    R4: 'r4',
    R5: 'r5',
    R6: 'r6',
    TOLERANCE: 'tolerance',
    TEMPCO: 'tempco',
  },

  ERROR_PARAMS: {
    TOTAL_ERROR: 'totalerror',
  },

  DACS: {
    MULTIPLYING: 'multiplying',
    VOLTAGE_OUTPUT: 'voltage output',
    CURRENT_SOURCE: 'current source',
    CURRENT_SOURCE_SINK: 'current source sink',
    FAST_PRECISION: 'fast precision',
  },

  TOPOLOGY_OPTIONS: {
    // base
    BUFFER: 'buffer',
    NO_BUFFER: 'no buffer',
    NONE: 'none',
    INTERNAL: 'internal',
    EXTERNAL: 'external',
    EXTERNAL_RESISTORS: 'external resistors',

    // non-inverting
    NON_INVERTING_BUFFER: 'non inverting buffer',
    NON_INVERTING_NO_BUFFER: 'non inverting no buffer',

    // inverting
    INVERTING: 'inv',

    // Iout/Vout
    IOUT: 'iout',
    VOUT: 'vout',

    OUTPUT_RANGE: 'outputrange',
    DAC_TYPE_VOLTAGE_OUT: 'voltage out',
    DAC_TYPE_CURRENT_OUT: 'current out',
  },

  TOPOLOGY_INPUTS: {
    MULTIPLYING_DAC: 'multiplying dac',
    VOLTAGE_REFERENCE: 'voltage reference',
    OUTPUT_RANGE: 'outputrange',
    NON_INVERTING: 'non inverting',
    INVERTING: 'inverting',
    OUTPUT: 'output',
    IOUT_OR_VOUT: 'iout or vout',
    RSET: 'external or internal rset',
    FP_NON_INVERTING: 'fp non inverting',
    FP_DAC_TYPE: 'fp dac type',
    FP_DAC_OUTPUT: 'fp dac output',
  },

  SIGNAL_CHAIN_ITEMS: {
    VOLTAGE_REFERENCE: 'volt ref',
    INTERNAL_VOLTAGE_REFERENCE: 'internal volt ref',
    INVERTING_AMP: 'inv amp',
    INVERTING_BUFFER: 'inv buffer',
    NON_INVERTING_AMP: 'non inv amp',
    NON_INVERTING_BUFFER: 'non inv buffer',
    OUTPUT_AMP: 'output amp',
    OUTPUT_BUFFER: 'output buffer',
    BUFFER: 'buffer',
    EXTERNAL_RSET: 'external rset',
  },

  SVG_PARTS: {
    voltage_output_dac: 'vout-dac',
    multiplying_dac: 'mult-dac',
    current_source_dac: '_4-20ma-dac',
    current_source_sink_dac: '_4-20ma-dac',
    fast_precision_dac: 'fp-dac',
    voltage_reference: 'voltage-reference',
    non_inverting_amplifier: 'non-inverting-amplifier',
    non_inverting_buffer: 'non-inverting-buffer',
    inverting_amplifier: 'inverting-amplifier',
    inverting_buffer: 'inverting-buffer',
    output_amplifier: 'output-amplifier',
    output_buffer: 'output-buffer',
    buffer: 'buffer',
    external_rset: 'external-rset',
  },

  RESISTORS: {
    INVERTING: 'inverting',
    NON_INVERTING: 'non-inverting',
    OUTPUT: 'output',
    EXTERNAL_RSET: 'external rset',
  },

  OUTPUT_VOLTAGE: {
    POSITIVE: 'positive',
    NEGATIVE: 'negative',
  },

  TAB: {
    NEXT: 'next',
    PREVIOUS: 'previous',
  },

  TAB_INDEXES: {
    DAC_TYPE: 0,
    APP_PARAMS: 1,
    CIRCUIT_DESIGN: 2,
  },

  SVG: {
    CONFIG: {
      BASE: 'base',
      CUSTOM_LABELS: 'customLabels',
      NO_INV_RES: 'noInvRes',
      INTERNAL_INV_RES: 'internalInvertingRes',
      EXTERNAL_INV_RES: 'externalInvertingRes',
    },
    ALTERATION_TYPES: {
      HIDE: 'hideItem',
      ADD_LINK: 'addLink',
      ADD_OUTPUT_VOLTAGE: 'addOutputVoltage',
      RESIZE_VIEWBOX: 'resizeViewbox',
      CHANGE_TRANSFORM: 'changeTransform',
    },
    LINK_TYPES: {
      DAC: 'dac',
    },
    OUTPUT_VOLTAGE: {
      REFERENCE: {
        ID: 'Vref_value',
      },
      POSITIVE_DAC: {
        ID: 'Vrefpdac_value',
        HIDE: 'Vrefpdac_hide',
      },
      NEGATIVE_DAC: {
        ID: 'Vrefndac_value',
        HIDE: 'Vrefndac_hide',
      },
      DAC: {
        ID: 'Vrefdac_value',
        HIDE: 'Vrefdac_hide',
      },
      OUTPUT: {
        ID: 'Vout_value',
      },
    },
    SIGNAL_CHAIN_TO_SVG_ID_MAP: {
      VOLTAGE_REFERENCE: {
        GROUP: 'External_Reference',
        NAME: 'REF_Name',
      },
      INTERNAL_VOLTAGE_REFERENCE: {
        GROUP: 'Internal_Reference',
        NAME: '', //there is no selected part in this case
      },
      INVERTING_AMPLIFIER: {
        GROUP: 'Inverting_Amplifier',
        NAME: 'Inverting_Amplifier_Name',
      },
      INVERTING_BUFFER: {
        GROUP: 'Inverting_Buffer',
        NAME: 'Inverting_Buffer_Name',
      },
      NON_INVERTING_AMPLIFIER: {
        GROUP: 'Non-Inverting_Amplifier',
        NAME: 'Non-Inverting_Amplifier_Name',
      },
      NON_INVERTING_BUFFER: {
        GROUP: 'Non-Inverting_Buffer',
        NAME: 'Non-Inverting_Buffer_Name',
      },
      EXTERNAL_RSET: {
        GROUP: 'External_Rset',
        NAME: '', // There is no selected part for rset
      },
      OUTPUT_AMPLIFIER: {
        GROUP: 'Output_Amplifier',
        NAME: 'Output_Amplifier_Name',
      },
      OUTPUT_BUFFER: {
        GROUP: 'Output_Buffer',
        NAME: 'Output_Amplifier_Name',
      },
      BUFFER: {
        GROUP: 'Buffer',
        NAME: 'Buffer_Name',
      },
    },
  },

  CLASSES: {
    ASC_SORT_BUTTON: 'asc-button',
    DESC_SORT_BUTTON: 'desc-button',
    SORT_ORDER: 'sort-order',
    HIDDEN_ITEM: 'hidden-item',
    SELECTED_ROW: 'selected-row',
    DISABLED_ROW: 'disabled-row',
    ERROR_ROW: 'error-row',
    NUMERIC_SLICK_CELL: 'slick-cell-numeric',
    DEFAULT_SLICK_CELL: 'slick-cell-default',
    PART_NUMBER_CELL: 'part-number-cell',
    HIGHLIGHT: 'highlight',
  },

  CDP: {
    // other types: [ 'String', 'Pulldown', 'Date' ],
    NUMERIC_TYPES: ['Floating Point', 'Integer'],
    INTERNAL: 'internal',
    EXTERNAL: 'external',

    PARAMETERS: {
      TEMPERATURE_RANGE: 'temperature',
      VREF_EXTERNAL_TYP: 'VrefExternal',
      VREF_POS_EXTERNAL: {
        MIN: 'vRefPositiveExternalMin',
        MAX: 'vRefPositiveExternalMax',
      },
      VREF_NEG_EXTERNAL: {
        MIN: 'vRefNegativeExternalMin',
        MAX: 'vRefNegativeExternalMax',
      },
      INVERTING_RESISTORS: {
        HAS_INTERNAL: 'internalResistors',
        INTERNAL: 'referenceResistor',
        TOLERANCE: 'refResistorMatch',
        TEMPCO: null, // NOT SURE WHAT THIS IS RIGHT NOW
      },
      OUTPUT_RESISTORS: {
        INTERNAL: 'feedbackResistor',
      },
      HAS_INTERNAL_OUTPUT_AMPLIFIER: 'outputAmplifier',
      HAS_VREF_NEGATIVE_PIN: 'vRefNegativePin',
      HAS_VREF_NEG_INTERNAL_BUFFER: 'vRefNegativeBuffer',
      HAS_VREF_POS_INTERNAL_BUFFER: 'vRefPositiveBuffer',
      VREF_SOURCE: 'vrefSource',
      VREF_LEVEL_INTERNAL: 'vrefLevelInternal',
      FS_ERROR: 'gainErrorPercentFsTyp',
      DAC_INL: 'dacVoutInlMax',
      RES: 'resolution',
      //VOFFSET: 4187,
      VOUT: 'voutV',
      VOUT_TEMPCO_MAX: 'voutTempcoMaxppmC',
      MULTIPLYING_BW: 'dacMultiplyingBandwidth',
      NOISE_DENSITY: 'vNoiseDensity',
      OUTPUT_VOLTAGE: 'voutV',
      DAC_INPUT_RESISTANCE: 5464,
      INITIAL_ACCURACY: 'initialAccuracyMax',
      TEMP_COEFFICIENT: 'gainTC',
      MIN_WORKING_TEMP: 'tempMin',
      MAX_WORKING_TEMP: 'tempMax',
      LOAD_REGULATION: 'loadRegulationppmmA',
      OUT_CURRENT: 5349,
      // REF_POWER_SUPPLY_RIPPLE: 0000, // ?
      LINE_REGULATION: 'lineRegulationMaxppmV',
      V_NOISE: 'vnoiseTyp',
      REF_OUT_VOLTAGE: 'voutV',

      VOS: 'vosMaxV',
      INPUT_VOLTAGE: 'voutV',
      INPUT_VOLTAGE_FROM_PARAMS: 3972,
      CMRR_MIN: 'cmrr',
      RESISTOR_TOLERANCE: 5031,
      RESISTOR_MATCHING: 5467,
      RSET_RESISTANCE: 'externalResistor',
      AVO: 'openLoopVoltageGain',
      INPUT_OFFSET_CURRENT: 'inputOffsetCurrentTyp',
      INPUT_OFFSET_DRIFT: 'vosTCMax',

      OUTPUT_RANGE_OPTIONS: 'vOutRange',
      TUE_IOUT_MAX: 'totalUnadjustedErrorPercentFSR',
      DAC_TYPE: 'dacType',
      VREF_INITIAL_ACCURACY_MAX: 'vrefInitialAccuracyMax',
      VREF_TEMPCO_MAX: 'vrefTcMaxppmC',
      INPUT_RESISTANCE: 'inputResistance',
      GAIN_ERROR_PERCENT_FS_MAX: 'gainErrorPercentFsMax',
      GAIN_TC_TYP: 'gainTcTyp',
      OFFSET_TEMP_CO: 'vosTC',
      OFFSET_VOLTAGE_ERROR_V: 'dacVOffseterror',
      OFFSET_ERROR: 'offsetVoltageErrorPpm',
      TOTAL_UNADJUSTED_ERROR: 'dacTotalUnadjustedError',
      PSRR_DC_MIN: 'psrrDcMin',
      INPUT_OFFSET_CURRENT_MAX: 'iosMaxA',
      BIAS_INPUT_CURRENT: 'ibiasMaxA',
      TUE_IOUT_EXTERNAL_RSET: 'tueIoutExternalRset',
      TUE_IOUT_INTERNAL_RSET: 'tueIoutInternalRset',
      VREF_V_NOISE: 'vrefVNoise',
    },
  },

  FILTER: {
    SLIDERS: 'Sliders',
    CHECKBOXES: 'Checkboxes',
    TEXTBOX: 'Textbox',
    SELECTALL: 'select all',
    SELECTNONE: 'select none',
    MIN: 'min',
    MAX: 'max',
  },
};
